// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"styles_infoWrapper__i7zfZ","infoItem":"styles_infoItem__85H_A","colorText":"styles_colorText__3q1gu","workTime":"styles_workTime__34QJP","map":"styles_map__9HP-Y"};